/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review2_SubInputs */

const es_landing_review2_sub = /** @type {(inputs: Landing_Review2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neumática 6 m`)
};

const gl_landing_review2_sub = /** @type {(inputs: Landing_Review2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neumática 6 m`)
};

const en_landing_review2_sub = /** @type {(inputs: Landing_Review2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 m RIB`)
};

/**
* | output |
* | --- |
* | "6 m RIB" |
*
* @param {Landing_Review2_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review2_sub = /** @type {((inputs?: Landing_Review2_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review2_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review2_sub(inputs)
	if (locale === "en") return en_landing_review2_sub(inputs)
	return es_landing_review2_sub(inputs)
});